import { Box, Stack, Typography, useTheme } from "@mui/material";
import { useAtom } from "jotai";
import { activityPeriodAtom } from "../../store";
import { PeriodMenu } from "../components/PeriodMenu";
import { FeedbackReceivedCard } from "./components/FeedbackReceivedCard";
import { QualityAssuranceCard } from "./components/QualityAssuranceCard";
import { TicketByPriorityCard } from "./components/TicketByPriorityCard";
import { TicketsByBoardCard } from "./components/TicketsByBoardCard";
import { TimesheetsCard } from "./components/TimesheetsCard";
import { ACTIVITY_PERIOD_OPTIONS } from "./periodOptions";

export const ActivitySection = () => {
  const theme = useTheme();
  // One filter for the section — every card below reads this same period.
  const [period, setPeriod] = useAtom(activityPeriodAtom);

  return (
    <Stack
      sx={{
        // Fills whatever height is left under the header on a tall viewport, and
        // falls back to its natural size on a short one — where the dashboard
        // scrolls instead of the cards collapsing.
        flex: 1,
        backgroundColor: theme.palette.neutral.main,
        borderRadius: "8px",
        p: "16px 24px",
      }}
    >
      {/* Content caps at 1600px and centres itself, so 1920/2560/4K screens all
          render the same dashboard width instead of stretching the cards. */}
      <Stack
        sx={{
          flex: 1,
          width: "100%",
          maxWidth: "1600px",
          mx: "auto",
          minWidth: 0,
          gap: "16px",
        }}
      >
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            justifyContent: "space-between",
            gap: "8px",
            minHeight: "28px",
            flexShrink: 0,
          }}
        >
          <Typography variant="h6" sx={{ color: theme.palette.lightBg.high }}>
            Activity & performance
          </Typography>

          <PeriodMenu
            options={ACTIVITY_PERIOD_OPTIONS}
            value={period}
            onChange={setPeriod}
            ariaLabel="Activity and performance period"
          />
        </Stack>

        {/* Two wide chart cards, then the three summary cards. Both grids reflow
            so a narrow viewport stacks the cards instead of squeezing them. */}
        <Box
          sx={{
            display: "grid",
            flexShrink: 0,
            gap: "12px",
            gridTemplateColumns:
              "repeat(auto-fit, minmax(min(360px, 100%), 1fr))",
            "& > *": { minWidth: 0 },
          }}
        >
          <TicketByPriorityCard />
          <TicketsByBoardCard />
        </Box>

        <Box
          sx={{
            display: "grid",
            flexShrink: 0,
            gap: "12px",
            gridTemplateColumns: "2.5fr 4fr 3fr",
            "& > *": { minWidth: 0 },
          }}
        >
          <TimesheetsCard />
          <QualityAssuranceCard />
          <FeedbackReceivedCard />
        </Box>
      </Stack>
    </Stack>
  );
};
